<template lang="pug">
div(v-if="features.length")
  h3(v-if="top.length") {{$t('page.areas._area.features:rate_destination.good_features')}}
  template(v-for="feature in top")
    h4
      ws-icon(small color="success") plus
      | {{$t(`skihall_feature_title.${feature.type.toLowerCase()}_${feature.rating}`)}}
    ws-content(:markdown="feature.text" tag="span")

  h3(v-if="bad.length") {{$t('page.areas._area.features:rate_destination.bad_features')}}
  template(v-for="feature in bad")
    h4
      ws-icon(small color="error") minus
      | {{$t(`skihall_feature_title.${feature.type.toLowerCase()}_${feature.rating}`)}}
    ws-content(:markdown="feature.text" tag="span")

  h3(v-if="medium.length") {{$t('page.areas._area.features:rate_destination.other_features')}}
  template(v-for="feature in medium")
    h4
      ws-icon(small color="warning") tilde
      | {{$t(`skihall_feature_title.${feature.type.toLowerCase()}_${feature.rating}`)}}
    ws-content(:markdown="feature.text" tag="span")

</template>

<script>
export default {
	props: {
		features: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		top() {
			return this.features.filter(feature => feature.rating >= 3);
		},
		medium() {
			return this.features.filter(feature => feature.rating === 2);
		},
		bad() {
			return this.features.filter(feature => feature.rating <= 1);
		}
	}
};
</script>
